var map = {
	"./amex-data.svg": "7f12",
	"./klarna-data.svg": "897e",
	"./lastschrift-data.svg": "7248",
	"./mastercard-data.svg": "e18e",
	"./paypal-data.svg": "5e78",
	"./rechnung-data.svg": "a5f3",
	"./sofortueberweisung-data.svg": "286d",
	"./visa-data.svg": "b312",
	"./vorauskasse-data.svg": "d9f3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "04f5";